import { HttpInterceptorFn } from '@angular/common/http';
import { TokenHelper } from '../helpers/token.helper';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const accessToken = TokenHelper.getAccessToken();

  request = request.clone({
    setHeaders: {
      'ngrok-skip-browser-warning': 'true',
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
    },
  });

  return next(request);
};
